<template>
  <NxInput
    name="vinculoEmpregaticio"
    type="text"
    label="Vinculo Empregatício:"
    placeholder="Digite o vinculo empregatício"
    :value="localValue"
    @update:value="handleValueUpdate"
  ></NxInput>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputVinculoEmpregaticio',
  mixins: [useReactiveModelMixin('value')],
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputVinculoEmpregaticio.vue